// 仕様書「ルールと数値」の値。数値を変えるときは仕様書を先に直す
export const RULES = {
  /** 1 回の指示で届け先（＝配送）は 4 か所まで */
  maxDropsPerBatch: 4,
  /** 1 回の指示の行き先（積む＋届ける）は 12 か所まで */
  maxStopsPerBatch: 12,
  /** 行き先ごとの作業時間の目安（分）の既定値 */
  defaultWorkMin: 10,
  /** 未受付の警告（分） */
  unacceptedAlertMin: 3,
  /** 運行表で、予定（受けたときの見込み）よりこれだけ遅れた枠を黄色にする */
  timelineBehindMin: 15,
  /** 点呼の確認待ちを強い警告にするまで（分） */
  rollCallWaitingAlertMin: 5,
  /** 未割り当ての配送：注意・警告（分） */
  unassignedWarnMin: 15,
  unassignedAlertMin: 30,
  /** 休息期間がこの時間未満なら勤務を開始できない（時間） */
  minRestHours: 9,
  /** 休息期間がこの時間未満なら事務所に注意（時間） */
  restCautionHours: 11,
  /** 1 ヶ月の拘束時間の上限（分）：284 時間（改善基準告示） */
  monthlyRestraintMin: 284 * 60,
  /** 1 日の拘束時間：注意 12 時間・警告 13 時間・上限 15 時間（分） */
  dailyRestraintWarnMin: 12 * 60,
  dailyRestraintAlertMin: 13 * 60,
  dailyRestraintMaxMin: 15 * 60,
  /** 通信なし：位置がこの分数届かなければ地図で灰色、もう一段で事務所に警告 */
  noSignalGrayMin: 5,
  noSignalAlertMin: 10,
  /** 停車：半径 50m 以内に 5 分以上。理由不明は 15 分で事務所に警告 */
  stopRadiusM: 50,
  /** 完了を押した場所が行き先からこれ以上離れていたら、本当に完了するか確認する（仕様書「撮影」） */
  completeFarM: 300,
  /** 回る順番のおすすめ（仕様書「回る順番のおすすめ」）：道のりは直線の 1.3 倍、速さは時間帯ごと（平日の朝夕は遅い）。
   * 事務所の走行の記録がその時間帯で 30 分以上たまったら、記録の平均の速さを使う。遅れは 1 分を 5 分ぶんの重さで避ける */
  routeRoadFactor: 1.3,
  routeSpeedKmh: [35, 35, 35, 35, 35, 32, 28, 18, 18, 22, 25, 25, 25, 25, 25, 25, 22, 18, 18, 25, 30, 32, 35, 35] as readonly number[],
  routeSpeedWeekendKmh: 28,
  routeLearnMinSec: 1800,
  routeLateWeight: 5,
  /** 行き先がこの数までなら、すべての並びを調べる。多ければ近い順＋入れ替え */
  routeExactMax: 9,
  /** これより短くしかならないなら、今の順のままにする（分） */
  routeMinGainMin: 3,
  /** 走行データ：時速 100km 以上が 1 分続いた区間に印。1 回に見られるのは 92 日まで */
  fastKmh: 100,
  fastSec: 60,
  drivingMaxDays: 92,
  /** 編集ロック：操作がないまま 2 分で切れる。画面は 30 秒ごとに延ばす（仕様書「同時編集の防止」） */
  lockTtlSec: 120,
  lockHeartbeatSec: 30,
  /** 定期便：予定は 3 ヶ月先（92 日）まで作る（仕様書「定期便の予定」） */
  scheduleAheadDays: 92,
  /** チャット（仕様書「事務所とのチャット」）：本文 500 文字。ドライバーからのメッセージが 5 分未読なら事務所に警告。走行中（時速 10km 以上）は入力できない */
  chatTextMax: 500,
  chatUnreadAlertMin: 5,
  chatLockKmh: 10,
  chatKeepDays: 366,
  /** 定型文：20 個まで・1 個 60 文字まで */
  phrasesMax: 20,
  phraseMax: 60,
  stopMin: 5,
  unknownStopAlertMin: 15,
  /** 連続運転：3 時間 30 分で注意、4 時間で警告（改善基準告示） */
  continuousDriveWarnMin: 210,
  continuousDriveAlertMin: 240,
  /** 連続運転を区切る休憩：1 回 10 分以上を合計 30 分 */
  breakValidMin: 10,
  breakTotalMin: 30,
  /** 停車の理由「その他」のメモの文字数 */
  stopMemoMax: 50,
  /** 配送指示の行き先ごとのメモ（ドライバーのその行き先の画面に出す） */
  visitMemoMax: 100,
  /** 電池の残りがこの % 以下なら注意の印 */
  lowBatteryPct: 20,
  /** 勤務中に位置を取る間隔（秒） */
  locationIntervalSec: 15,
  /** マナーモードの警告を閉じてから再表示するまで（分） */
  silentRewarnMin: 10,
  /** 位置の記録の保存期間（日） */
  locationKeepDays: 92,
  /** 事務所からのメモの文字数 */
  memoMax: 200,
  /** 荷主の会社名の文字数 */
  clientNameMax: 60,
  /** 同意書の版。文面を変えたら上げる（次のログインでもう一度同意を求める） */
  consentVersion: 1,
  /** 招待コードの期限（日） */
  inviteDays: 7,
  /** 写真：1 か所の行き先は 10 枚まで、点呼は 2 枚、問題報告は 5 枚。1 枚 4MB まで */
  photosPerVisit: 10,
  photosPerRollCall: 2,
  photosPerIssue: 5,
  photoMaxBytes: 4 * 1024 * 1024,
  /** 写真の保存期間（日）：配送 30 日、点呼 1 年 */
  photoKeepDaysDelivery: 30,
  photoKeepDaysRollCall: 366,
  /** 名前の文字数 */
  nameMax: 40,
} as const;

export const ROLES = ['admin', 'manager', 'assistant', 'dispatcher'] as const;
export type Role = (typeof ROLES)[number];

/** 役割ごとにできること（仕様書「API の権限」の表）。書いていない操作はだれもできない */
export const PERMISSIONS = {
  dispatch: ['admin', 'manager', 'assistant', 'dispatcher'],
  confirmRollCall: ['admin', 'manager', 'assistant'],
  viewRecords: ['admin', 'manager', 'assistant'],
  viewPhotos: ['admin', 'manager', 'assistant', 'dispatcher'],
  register: ['admin', 'manager'],
  approveDevice: ['admin', 'manager'],
  manageStaff: ['admin'],
  viewAudit: ['admin', 'manager'],
} as const satisfies Record<string, readonly Role[]>;
export type Permission = keyof typeof PERMISSIONS;

export const can = (role: Role, perm: Permission) => (PERMISSIONS[perm] as readonly Role[]).includes(role);
